module.exports = __webpack_public_path__ + "5a78d5f3af9a450a265f56069a9b12ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/informations/aboutUs/Leah.png
// module id = 1483
// module chunks = 0